<template>
    <ul class="nav nav-tabs bg-transparent tab-lemon">
        <li class="nav-item">
            <a
                :class="this.activeOption == 'admin-root' ? 'nav-link active disabled' : 'nav-link'"
                @click.prevent="navigate('Admin', 'admin-root')"
            >Inicio</a>
        </li>
        <li class="nav-item">
            <a
                :class="this.activeOption == 'admin-activities' ? 'nav-link active disabled' : 'nav-link'"
                @click.prevent="navigate('Admin', 'admin-activities')"
            >Actividades</a>
        </li>
        <li class="nav-item">
            <a
                :class="this.activeOption == 'admin-activity-groups' ? 'nav-link active disabled' : 'nav-link'"
                @click.prevent="navigate('Admin', 'admin-activity-groups')"
            >Grupos de actividades</a>
        </li>
        <li class="nav-item">
            <a
                :class="this.activeOption == 'admin-stop-schedules' ? 'nav-link active disabled' : 'nav-link'"
                @click.prevent="navigate('Admin', 'admin-stop-schedules')"
            >Ruta de paradas por grupos</a>
        </li>
        <li class="nav-item">
            <a
                :class="this.activeOption == 'admin-geopoints' ? 'nav-link active disabled' : 'nav-link'"
                @click.prevent="navigate('Admin', 'admin-geopoints')"
            >Hoteles y pickups</a>
        </li>
        <li class="nav-item">
            <a
                :class="this.activeOption == 'admin-hotel-stop-groups' ? 'nav-link active disabled' : 'nav-link'"
                @click.prevent="navigate('Admin', 'admin-hotel-stop-groups')"
            >Hoteles, paradas por grupos</a>
        </li>
        <li class="nav-item">
            <a
                :class="this.activeOption == 'admin-subzones' ? 'nav-link active disabled' : 'nav-link'"
                @click.prevent="navigate('Admin', 'admin-subzones')"
            >Resorts</a>
        </li>
        <li class="nav-item">
            <a
                :class="this.activeOption == 'admin-pickupzones' ? 'nav-link active disabled' : 'nav-link'"
                @click.prevent="navigate('Admin', 'admin-pickupzones')"
            >Subzonas</a>
        </li>
        <li class="nav-item">
            <a
                :class="this.activeOption == 'admin-suprazones' ? 'nav-link active disabled' : 'nav-link'"
                @click.prevent="navigate('Admin', 'admin-suprazones')"
            >Zonas</a>
        </li>
        <li class="nav-item">
            <a
                :class="this.activeOption == 'admin-bus-companies' ? 'nav-link active disabled' : 'nav-link'"
                @click.prevent="navigate('Admin', 'admin-bus-companies')"
            >Companías de bus</a>
        </li>
        <li class="nav-item">
            <a
                :class="this.activeOption == 'admin-bus-companies-prices' ? 'nav-link active disabled' : 'nav-link'"
                @click.prevent="navigate('Admin', 'admin-bus-companies-prices')"
            >Precios de companías de bus</a>
        </li>
        <li class="nav-item">
            <a
                :class="this.activeOption == 'admin-activity-duration-types' ? 'nav-link active disabled' : 'nav-link'"
                @click.prevent="navigate('Admin', 'admin-activity-duration-types')"
            >Duración actividades (Guías)</a>
        </li>
        <li class="nav-item">
            <a
                :class="this.activeOption == 'admin-guides' ? 'nav-link active disabled' : 'nav-link'"
                @click.prevent="navigate('Admin', 'admin-guides')"
            >Guías</a>
        </li>
        <li class="nav-item">
            <a
                :class="this.activeOption == 'admin-export' ? 'nav-link active disabled' : 'nav-link'"
                @click.prevent="navigate('Admin', 'admin-export')"
            >Exportación</a>
        </li>
        <li class="nav-item">
            <a
                :class="this.activeOption == 'admin-secrets' ? 'nav-link active disabled' : 'nav-link'"
                @click.prevent="navigate('Admin', 'admin-secrets')"
            >Secretos</a>
        </li>
        <li class="nav-item">
            <a
                :class="this.activeOption == 'admin-help' ? 'nav-link active disabled' : 'nav-link'"
                @click.prevent="navigate('Admin', 'admin-help')"
            >Ayuda</a>
        </li>
    </ul>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    methods: {
        async navigate(tab, option) {
            await this.$store.dispatch("layout/setActiveTabAndOption", {tab: tab, option: option})
        }
    },
    computed: {
      ...mapGetters(['activeTab', 'activeOption'])
  },
}
</script>